import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ParameterService } from '../../../services/parameter.service';
import { PaymentService } from '../../../services/payment.service';
import { Payment } from '../../../models/payment';
import { MonerisResponse } from '../../../models/moneris-response';

declare var monerisCheckout: any;

@Component({
  selector: 'app-moneris-checkout',
  templateUrl: './moneris-checkout.component.html',
  styleUrls: ['./moneris-checkout.component.css']
})
export class MonerisCheckoutComponent implements OnInit {

  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Input() source: string;
  @Input() userId: string;
  @Input() allowCardSaving: boolean;
  @Input() forceCardSaving: boolean;
  @Input() defaultCardSaving: boolean;

  @Output() paymentSucces: EventEmitter<any> = new EventEmitter();
  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  loading: boolean;
  savingCard: boolean;
  checkout: any;

  private apiURL = environment.apiURL;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private parameterService: ParameterService,
              private paymentService: PaymentService) { }

  ngOnInit() {
    this.loading = false;
    this.savingCard = false;
    if (this.allowCardSaving && this.forceCardSaving) {
      this.savingCard = true;
    } else if (this.allowCardSaving && this.defaultCardSaving) {
      this.savingCard = this.defaultCardSaving;
    }
  }

  onClickPay() {
    this.loading = true;
    this.paymentService.getPayment(this.paymentToken, this.chamberId)
    .then((payment: Payment) => {
      //Open moneris checkout
      this.checkout = new monerisCheckout();
      if (!environment.production) {
        this.checkout.setMode('qa');
      } else {
        this.checkout.setMode('prod');
      }
      this.checkout.setCheckoutDiv('monerisCheckout');
      this.checkout.setCallback('page_loaded', this.loadedCallback());
      this.checkout.setCallback('cancel_transaction', this.cancelCallback());
      this.checkout.setCallback('error_event', this.errorCallback());
      this.checkout.setCallback('payment_complete', this.paymentCompleteCallback(this.chamberId, this.paymentToken));
      this.checkout.startCheckout(payment.MonerisCheckout.Ticket);
      this.loading = false;
    })
    .catch((error) => {
      this.loading = false;
      this.paymentError.emit(error);
    });
  }

  loadedCallback(): any {
    return (response: string) => {
      console.log('moneris checkout loaded');
    };
  }

  cancelCallback(): any {
    return (response: string) => {
      console.log('moneris checkout has been canceled');
      this.checkout.closeCheckout();
    };
  }

  errorCallback(): any {
    return (responseString: string) => {
      const response = JSON.parse(responseString);
      console.log('moneris checkout has raised an error', response.response_code);
      this.checkout.closeCheckout();
    };
  }

  paymentCompleteCallback(chamberId: string, registrationId: string): any {
    return (responseString: string) => {
      const response: MonerisResponse = JSON.parse(responseString);
      console.log('moneris checkout complete');
      this.checkout.closeCheckout();
      if (response.response_code === '001') {
        this.loading = true;
        this.PostMonerisPayment(response.ticket, chamberId, registrationId)
        .then(() => {
          this.loading = false;
          this.paymentSucces.emit(null);
        })
        .catch((reterror) => {
          this.loading = false;
          this.paymentError.emit(reterror);
        });
      } else {
        console.log('moneris error code:', response.response_code);
        this.paymentError.emit('Error');
      }
    };
  }

  public PostMonerisPayment(ticket: string, chamberId: string, paymentToken: string): Promise<any> {
    let callbackUrl = this.apiURL + 'payment/' + ticket + '/moneris?chamberid=' + chamberId + '&paymenttoken=' + paymentToken;
    if (this.source && this.source.trim() !== '') {
      callbackUrl += '&paymentsource=' + this.source;
    }
    if (this.userId && this.userId.trim() !== '') {
      callbackUrl += '&userid=' + this.userId;
    }
    if (this.savingCard && this.savingCard === true) {
      callbackUrl += '&savecardinfo=' + this.savingCard;
    }

    const callHeaders: HttpHeaders = this.headers;
    return this.http.post<any>(callbackUrl, null, {headers: callHeaders})
    .toPromise()
    .then(response => response)
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.error || error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/moneris-checkout/moneris-checkout.component.ts